// extracted by mini-css-extract-plugin
module.exports = {"insight":"insight_insight__p9meD"};